import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import MainLayout from './app/layout/MainLayout';
import { NewAuthLayout } from './components/layouts/NewAuthLayout';
import { RedirectIfAuthed, RequireAuth } from './components/RequireAuth';
import { ScrollToTop } from './components/ScrollToTop';
import { Loader } from '@/shared/ui/Loader';
// Auth-страницы + layouts/guards/404 — eager (нужны на первом экране/мгновенно).
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { TwoFactorAuth } from './pages/auth/TwoFactorAuth';
import { RequestPasswordReset } from './pages/auth/RequestPasswordReset';
import { ResetPassword } from './pages/auth/ResetPassword';
import { VerifyEmail } from './pages/auth/VerifyEmail';
import { TokenPage } from './pages/auth/TokenPage';
import { NotFound } from './pages/NotFound';
import { brand } from '@/brand';
import { buildRoutes, homePath } from '@/app/navigation/buildRoutes';
import { useNavTranslate } from '@/app/navigation/useNavTranslate';

// Кабинетные страницы больше не перечисляются здесь: их состав задаёт бренд
// (src/brand/*), а пути и lazy-компоненты живут в реестре
// src/app/navigation/screens.ts. Code-splitting сохранён — реестр держит те же
// React.lazy (см. docs/patterns.md → code-splitting).
// Auth-зона одинакова у всех брендов и остаётся жёстко прописанной ниже.

export function AppRouter() {
  const tNav = useNavTranslate();

  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Все auth-страницы мигрированы на новый стек, используют NewAuthLayout
          без Flatkit-обёрток. */}
      <Route
        element={
          <RedirectIfAuthed>
            <NewAuthLayout />
          </RedirectIfAuthed>
        }
      >
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="forgot-password" element={<RequestPasswordReset />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="verify" element={<VerifyEmail />} />
      </Route>

      {/* /auth/2fa — без RedirectIfAuthed, потому что юзер на этом этапе
          по legacy AuthContext всё ещё 'guest' (auth_key cookie ещё не
          выставлен). Сама страница сама проверяет state из RTK store. */}
      <Route element={<NewAuthLayout />}>
        <Route path="auth/2fa" element={<TwoFactorAuth />} />
        {/* /partners/token?id=&token= — impersonation из админки. Вне
            RedirectIfAuthed: должен срабатывать всегда (см. TokenPage). */}
        <Route path="token" element={<TokenPage />} />
      </Route>

      <Route
        element={
          <RequireAuth>
            <MainLayout>
              {/* Suspense в контентной зоне: shell (Sidebar/Header/Footer)
                  рендерится сразу, лоадер крутится только в области страницы,
                  пока грузится её lazy-чанк. */}
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </MainLayout>
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to={homePath(brand)} replace />} />
        {buildRoutes(brand, tNav)}
      </Route>

      <Route path="404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}
